import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Footer from "../../Components/Footer";
import img1 from "../../assets/images/Final_Logo.png";
import Header from "../../Components/Header";
import "./About.css";
import Cursor from "../../Components/Cursor";
import { ServicesSectionProvider } from "../../Context/ServiceSectionContext";


const About = () => {
 
    return (
        <>
            <ServicesSectionProvider>
                <Helmet>
                    <title>About Glyph - Making Things Happen</title>
                    <meta name="description" content="Learn more about Glyph, a dynamic and innovative company driven by a mission to transform ideas into reality. Glyph is focused on creativity, technology, and impact, excelling at delivering solutions that empower individuals and businesses to achieve their goals." />
                    <meta name="keywords" content="Glyph, innovation, creativity, technology, business solutions" />
                    <meta property="og:title" content="About Glyph - Making Things Happen" />
                    <meta property="og:description" content="Discover Glyph, a company that transforms ideas into reality through creativity and technology, empowering businesses and individuals." />
                    <meta property="og:image" content={img1} />
                    <meta property="og:type" content="website" />
                    <meta property="og:url" content={window.location.href} />
                </Helmet>
                <Cursor />
                <Header />
                <section className="custom-section ">
                    <div className="row justify-content-center">
                        <div className="col-12 text-center">
                            <div className="custom-video pt-5">
                                <img
                                    src={img1}
                                    alt="Glyph"
                                    className="logo-image img-fluid"
                                    data-aos="fade-up"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center mt-4">
                        <div className="col-md-8 mx-auto text-center">
                            <h1
                                className="main-text"
                                data-aos="fade-up"
                                data-aos-delay={300}
                                data-aos-duration={1500}
                            >
                                IT’S ALL ABOUT MAKING THINGS HAPPEN..
                            </h1>
                        </div>
                    </div>
                    <div className="row justify-content-center mt-3">
                        <div className="col-md-8 text-center">
                            <p
                                className="sub-text"
                                data-aos="fade-up"
                                data-aos-delay={500}
                                data-aos-duration={1500}
                            >
                                Glyph is a dynamic and innovative company driven by a mission to
                                transform ideas into reality. Focused on creativity, technology, and
                                impact, Glyph excels at delivering solutions that empower individuals
                                and businesses to achieve their goals.
                            </p>
                        </div>
                    </div>
                </section>
                
                <Footer />
            </ServicesSectionProvider>

        </>
    );
};

export default About;
